import { useState } from 'react'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function Register() {
  const { artist, register } = useAuth()
  const navigate = useNavigate()
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  if (artist) return <Navigate to="/dashboard" replace />

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setError('')
    const fd = new FormData(e.currentTarget)
    const password = fd.get('password') as string
    const confirm = fd.get('confirm') as string
    if (password !== confirm) {
      setError('Passwords do not match')
      return
    }
    try {
      setLoading(true)
      await register(
        (fd.get('email') as string).trim(),
        password,
        (fd.get('name') as string).trim(),
        (fd.get('phone') as string)?.trim() || undefined
      )
      navigate('/dashboard', { replace: true })
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registration failed')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <title>Registrer deg som kunstner — Originalene</title>
      <meta name="robots" content="noindex" />
      <div className="auth-card">
        <h1 className="auth-title">Lag kunstner konto</h1>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="name">Fullt navn</label>
            <input
              id="name"
              name="name"
              className="form-input"
              required
              autoFocus
              autoComplete="name"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              className="form-input"
              required
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="phone">
              Telefonnummer <span style={{ color: 'var(--muted)', fontWeight: 400 }}>(valgfritt)</span>
            </label>
            <input
              id="phone"
              name="phone"
              type="tel"
              className="form-input"
              autoComplete="tel"
              placeholder="+47 000 00 000"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">
              Passord <span style={{ color: 'var(--muted)', fontWeight: 400 }}>(min. 8 characters)</span>
            </label>
            <input
              id="password"
              name="password"
              type="password"
              className="form-input"
              required
              minLength={8}
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="confirm">Bekreft passord</label>
            <input
              id="confirm"
              name="confirm"
              type="password"
              className="form-input"
              required
              autoComplete="new-password"
            />
          </div>

          {error && <p className="form-error">{error}</p>}

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? 'Lager konto…' : 'Lag konto'}
          </button>
        </form>

        <p className="auth-footer">
          Har du allerede en konto? <Link to="/login">Logg inn</Link>
        </p>
      </div>
    </div>
  )
}
